import { OPERATORS } from 'src/app/services/constants';
import { BandTooltipStrategy } from './band-tooltip-strategy.interface';

export class PixxelBandTooltipStrategy implements BandTooltipStrategy {
  matches(operatorKey: string, operatorMetadata: any, taskSensor: any): boolean {
    return operatorKey === OPERATORS.PIXXEL && !!taskSensor?.selectedBands;
  }

  buildTooltip(operatorMetadata: any, taskSensor: any): string {
    const selectedBandId = taskSensor?.selectedBands;
    if (!selectedBandId) {
      return '';
    }

    // Resolve bandset name and metadata bandset: first check bands[].id, then bands[].bandInfo[].id
    let bandsetName: string | undefined;
    let metadataBandset: any[] | undefined;

    const directMatch = operatorMetadata?.bands?.find((b: any) => b.id === selectedBandId);
    if (directMatch) {
      bandsetName = directMatch.name;
      metadataBandset = directMatch.bandset;
    } else {
      for (const band of (operatorMetadata?.bands || [])) {
        const infoEntry = band.bandInfo?.find((info: any) => info.id === selectedBandId);
        if (infoEntry) {
          bandsetName = infoEntry.name;
          metadataBandset = infoEntry.bandset;
          break;
        }
      }
    }

    const prefix = bandsetName ? `Bandset: ${bandsetName}` : '';

    // Build band list from operatorMetadata bandset windows
    if (metadataBandset?.length) {
      const windowObj = metadataBandset[0];
      const allBands = (Object.values(windowObj) as any[][]).flat();
      const uniqueSortedBands = Array.from(
        new Map(allBands.map((b: any) => [b.name, b])).values()
      ).sort((a: any, b: any) => (a.wavelength ?? 0) - (b.wavelength ?? 0));
      const bandLines = uniqueSortedBands.map((b: any) =>
        b.wavelength ? `${b.name} (${b.wavelength} nm)` : b.name
      );
      const parts = [prefix, `Selected ${uniqueSortedBands.length} bands: ${bandLines.join(', ')}`];
      return parts.filter(Boolean).join('\n');
    }

    return prefix;
  }
}
